import { switchableParkIds } from "../../utils/users/activePark";
import { switchActivePark } from "../../utils/users/activeParkSwitch";
import { isResearchGuestProfile } from "../../utils/users/researchGuest";
import { matchesSearchWords, splitSearchWords } from "../../utils/search/searchMatch";

/**
 * Choix du parc à côté du nom du parc (étape 4 du chantier droits-multi-parcs,
 * .scratch/droits-multi-parcs/spec.md) : les parcs actifs du registre de la
 * personne, avec leur nom ; le staff AKONGO a en plus « Tous les parcs » (la
 * liste des parcs AKONGO, d'où il s'ajoute à un parc). Rien à proposer, pas de
 * bouton : un compte à un seul parc ne voit aucun changement.
 *
 * Interfaces Classique et Nouvelle partagent ce chargement et la bascule
 * (activeParkSwitch.js : rechargement complet, autres onglets compris).
 */
export const ALL_PARKS_PATHS = Object.freeze({ v1: "/ZooList", v2: "/v2/akongo/administration/establishments" });

export async function loadParkSwitcher({ userConnector, uid }) {
  if (!uid || typeof userConnector?._getOwnAccessGrant !== "function") return null;
  const local = await userConnector._getUserData();
  const profile = local?.data && typeof local.data === "object" ? local.data : {};
  // Invité recherche : aucun parc à choisir.
  if (isResearchGuestProfile(profile) && profile.akongoStaff !== true) return null;
  const { grant, grantState } = await userConnector._getOwnAccessGrant(uid);
  const ids = switchableParkIds({ user: profile, grant, grantState });
  const parks = await Promise.all(ids.map(async (zooId) => {
    let zooName = null;
    try {
      zooName = (await userConnector._getZooData(zooId))?.data?.zooName || null;
    } catch (_error) {
      zooName = null;
    }
    return { zooId, zooName: zooName || zooId };
  }));
  parks.sort((a, b) => a.zooName.localeCompare(b.zooName));
  const allParks = profile.akongoStaff === true;
  if (parks.length < 2 && !allParks) return null;
  return { parks, currentZooId: profile.userZoo?.value || profile.zooId || null, allParks };
}

/**
 * Parcs de la fenêtre de choix qui répondent à la recherche : nom ou identifiant,
 * sans accents ni casse, en sous-chaîne (règle commune des barres de recherche).
 */
export function filterParks(parks, query) {
  const words = splitSearchWords(query || "");
  return (parks || []).filter((park) => matchesSearchWords([park.zooName, park.zooId], words));
}

/** Bascule vers un parc du sélecteur : rechargement complet sur l'accueil. */
export function switchToPark({ userConnector, uid, park, storage = window.localStorage, location = window.location }) {
  return switchActivePark({
    uid,
    zooId: park.zooId,
    zooName: park.zooName,
    connector: userConnector,
    storage,
    location,
    homePath: "/",
  });
}
